import { MailOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { BUTTON_TYPE } from "@/constants/Button";
import { useResendInvite } from "@/hooks/queries/user";
import { useAppNotification } from "@/modules/app-notification";

const ResendInviteButton = ({ userId }) => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const mutation = useResendInvite(userId);

  const onResendInvite = () => {
    mutation.mutate(null, {
      onSuccess: () => {
        notify.success({ title: t("user:resendInvite.success") });
      },
      onError: () => {
        notify.error({ title: t("user:resendInvite.error") });
      },
    });
  };

  return (
    <Button
      icon={<MailOutlined />}
      type={BUTTON_TYPE.DEFAULT}
      role="button"
      disabled={mutation.isPending}
      onClick={onResendInvite}
    >
      {t("user:resendInvite.button")}
    </Button>
  );
};

ResendInviteButton.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default ResendInviteButton;
